import React from "react";
import { useContext, useEffect } from "react";
import { User } from "../../../service";
import ReusableForm from "../ReusableForm";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AuthBgImage from "assets/images/auth_bg.jpg";
import { UserContext } from "../../context/UserContext";
import { loginFields } from "../../constant/Home/Authentication";
import useApiHandler from "../../hooks/ApiHandler";
import Cookies from "universal-cookie";
import APPLICATION_SETTINGS from "../../../settings";

const LogIn = () => {
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserContext);
  const { callApi, loading } = useApiHandler();

  useEffect(() => {
    const checkUserAuth = async () => {
      const cookies = new Cookies();
      const token = cookies.get("token");

      // if (token) {
      //   await callApi(() => User.getMe(), {
      //     onSuccess: (response) => {
      //       if (response.data) {
      //         setUserData(response.data);
      //         // navigate(
      //         //   APPLICATION_SETTINGS.REDIRECT_TO_POST_SIGNUP_THANK_YOU_ON_LOGIN
      //         //     ? "/post-signup-thank-you"
      //         //     : "/dashboard"
      //         // );
      //         navigate("/dashboard")
      //       }
      //     },
      //     onError: (error) => {
      //       console.log("User not authenticated, staying on login page");
      //       // Clear invalid token
      //       cookies.remove("token", { path: "/" });
      //     },
      //   });
      // }
    };

    checkUserAuth();
  }, [navigate, setUserData, callApi]);

  const handleSubmit = async (values, { setSubmitting }) => {
    await callApi(() => User.login(values.email, values.password), {
      successMessage: "Logged in successfully!",
      onSuccess: async (response) => {
        // Set user data and navigate to dashboard
        if (response.data) {
          const userData = response.data.user || response.data;
          setUserData(userData);

          // Explicitly verify the token is valid and get full user profile before navigating
          try {
            const meResponse = await User.getMe();
            if (meResponse.data) {
              setUserData(meResponse.data);
            }
          } catch (e) {
            console.error("Post-login verification failed", e);
          }
        }
        navigate("/dashboard");
      },
      onError: (error) => {
        console.error("Login failed:", error);
      },
      finallyCallback: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat  p-4 md:p-6 lg:p-8 flex items-center justify-center relative"
      style={{ backgroundImage: `url(${AuthBgImage})` }}
    >
      {/* Overlay div */}
      <Toaster />{" "}
      <div
        className="absolute inset-0 bg-black"
        style={{ backgroundColor: "#00000033" }}
      />
      <div className="flex flex-col rounded-[20px]  p-4 md:p-6 lg:p-8  max-w-[540px]  justify-center items-center bg-white z-10">
        <ReusableForm
          title="Welcome Back!"
          description={null}
          initialValues={{
            email: "",
            password: "",
          }}
          fields={loginFields}
          handleClick={handleSubmit}
          submitButtonText="Log In"
          className="space-y-4 md:min-w-[450px]"
          forgotPass={true}
          loading={loading}
        >
          <p className="text-center  text-[14px] text-[#767676] tracking-[0.025em] font-medium leading-6">
            Are you a new user?{" "}
            <span
              className="text-[#2C8D48] cursor-pointer"
              onClick={() => navigate("/signup")}
            >
              {" "}
              Sign up
            </span>
          </p>
        </ReusableForm>
      </div>
    </div>
  );
};

export default LogIn;
